let currentSessionId = null;

export const getSessionId = () => {
    const stored = localStorage.getItem('sessionId');
    if (stored) return stored;
    
    return currentSessionId;
};

export const setAnonSessionId = (id) => {
    currentSessionId = id;
};